<template>
  <div class="nav-child-wrap-bg" :class="{ 'dark': isDark }">
    <div class="nav-lang-child-wrap" v-if="langData.child">
      <div
        class="nav-lang-child-item d-flex ai-center"
        v-for="(langItem, index) in langData.child"
        :key="index"
        @click="changeLang(langItem.lang)"
      >
        <span class="text">{{ langItem.label }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    langData: {
      type: Object,
      default: () => ({ child: [] }),
    },
    isDark: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    changeLang(lang) {
      this.$i18n.locale = lang;
      localStorage.setItem('locale', lang);
      this.$emit('change-lang', lang);
    },
  },
};
</script>

<style lang="scss" scoped>
.nav-child-wrap-bg {
  // display: none;
  padding-top: 10px;
  position: absolute;
  z-index: 999;
  left: 50%;
  transform: translateX(-50%);
  top: 40px;
  .nav-lang-child-wrap {
    border-radius: 12px;
    background: var(--navbar-wrap-child-language-bg);
    // border: var(--navbar-wrap-child-language-border);
    background: #152946;
    // border: 1px solid #2c4466;
    box-shadow: 0 6px 16px 0 rgba(45, 54, 86, 0.05);
    position: static;
    padding: 24px;
    display: flex;
    flex-direction: column;
    gap: 24px 0;
    .nav-lang-child-item {
      span {
        font-size: 16px;
        white-space: nowrap;
        color: var(--color-1);
        color: #ffffff;
        &:hover {
          color: #2980fe;
        }
      }
    }
  }

  &.dark {
    .nav-lang-child-wrap {
      background: #ffffff;
      .nav-lang-child-item {
        span {
          color: #000000;
          &:hover {
            color: #2980fe;
          }
        }
      }
    }
  }
}
</style>
